import styles from "./ImageViewer.module.css";

export const ImageViewer = ({ data }: { data: string }) => {
  return <div className={styles.imageViewer}>
    <img src={encodeURIComponent(data)} className={styles.image}></img>
  </div>
}